import { useEffect } from 'react';

import type { StepDetailProps } from '../types';
import { EmailVerificationResultView } from './EmailVerificationResultView';

/**
 * The module's read-only Detail for an Email Verification step.
 *
 * A THIN WRAPPER around `EmailVerificationResultView`, which is also what the session view's
 * `StepAccordion` renders — so the result is drawn by one component in both places rather than two
 * that can format a timestamp differently depending on which screen you are on.
 */
export function EmailStepDetail({ step, onReadyChange }: StepDetailProps) {
  // Nothing here is editable, so there is no form to submit and nothing to wait for. Reported once
  // so the host panel does not sit disabled waiting on a step that will never become "ready".
  useEffect(() => {
    onReadyChange(true);
  }, [onReadyChange]);

  return <EmailVerificationResultView resultJson={step.resultJson} />;
}
